import { SaveButton } from "@/components/admin";
import { Card } from "@/components/ui/card";
import { CalendarRange } from "lucide-react";
import {
  BooleanInput,
  Create,
  NumberInput,
  SimpleForm,
  TextInput,
} from "../common";

const LeaveTypeToolbar = () => (
  <div className="form-toolbar-premium">
    <SaveButton className="btn-green-action" label="Save Leave Type" />
  </div>
);

export const LeaveTypeCreate = () => (
  <Create title="Create Leave Type">
    <Card className="form-container">
      <div className="form-header-premium">
        <CalendarRange className="w-6 h-6 text-emerald-600" />
        <h2 className="text-2xl font-bold text-slate-900">Add Leave Type</h2>
      </div>
      <SimpleForm toolbar={<LeaveTypeToolbar />}>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          <TextInput source="name" label="Leave Type Name" />
          <TextInput source="code" label="Code" />
          <NumberInput source="days_per_year" defaultValue={0} label="Days Per Year" />
        </div>
        <div className="flex gap-6 mt-4">
          <BooleanInput source="paid" defaultValue label="Paid Leave" />
          <BooleanInput source="carry_forward" label="Carry Forward" />
        </div>
      </SimpleForm>
    </Card>
  </Create>
);
